import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'isString'
})
export class IsStringPipe implements PipeTransform {
	transform(value: any, _args?: unknown): any {
		return typeof value === 'string';
	}
}

@Pipe({
	name: 'isNullOrEmpty'
})
export class IsNullOrEmpty implements PipeTransform {
	transform(value: string | null, _args?: unknown): boolean {
		return typeof value !== 'string' || value.trim() === '';
	}
}
